import React from 'react';
import { Provider } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';
import securityComponent from './containers/bankingAlertsPageContainer';
import accountAlertsComponent from './containers/accountAlertspageContainer';
import accountAlertsMenuComponent from './containers/accountAlertsMenuPageContainer';
import manangeAccountAlertTypes from './containers/manageAlertTypeContainer'
import addOrEditMethodComponent from './containers/deliveryMethodContainer';
import { Route, Redirect, HashRouter, Switch } from 'react-router-dom';
import configureStore from './store';
import landingPageContainer from './containers/landingPageContainer';
import EditPageForMobile from './components/AlertPreferences/DeliveryMethods/EditPage';
import VerifyScreen from './components/AlertPreferences/DeliveryMethods/VerifyScreen';
import SMSDisclosuresScreen from './Shared/SMSDisclosuresScreen';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer } from 'react-notifications';
import DeliveryMethods from './containers/deliveryMethodContainer';
import { isMobile } from './helpers/utils';



const App = () => {
    const routes = [
        { path: "/", component: landingPageContainer },
        { path: "/LandingPage", component: landingPageContainer },
        { path: "/bankingAlerts/:name", component: securityComponent },
        { path: "/accountalerts/:accountno/:name/:nickname", component: isMobile() ? accountAlertsMenuComponent : accountAlertsComponent },
        { path: "/accountalerttypes/:name/:accountno/:nickname/:alertname", component: manangeAccountAlertTypes },
        { path: "/alertPreferences/addOrEditMethodComponent", component: addOrEditMethodComponent },
      
        { path: "/emailOrPhoneEdit/:id/:type", component: EditPageForMobile },
        { path: "/emailOrPhoneEdit/:type", component: EditPageForMobile },
        { path: "/verifyEmailOrPhone/:type/:id", component: VerifyScreen },
        { path: "/smsdisclosures", component: SMSDisclosuresScreen },
        { path: "/deliverymethods/addandedit", component: DeliveryMethods }     
    ];

    return (
        <Provider store={configureStore({})}>
            <HashRouter>
                <Switch>
                    <Redirect exact from="/manageTextBankingPage" to="/" />
                    <Redirect exact from="/bankingcommands" to="/" />
                    {
                        routes.map((route, index) => (
                            <Route
                                key={index}
                                exact
                                path={route.path}
                                component={route.component} />
                        ))
                    }
                </Switch>
            </HashRouter>
            <div aria-live="polite">
            <NotificationContainer />
            </div>
        </Provider>
    )
}

export default App;
